'use strict';

/**
 * @ngdoc factory
 * @name vTvPackage.vTvPackagePreloadImgFactory
 * @description Return a constructor with onSuccess and onError set for the new image loader
 * Inspired from angular-preload-image.js on git hub
 */

angular.module('v-tv-package').factory('vTvPackagePreloadImgFactory', function vTvPackagePreloadImgFactory() {
    return function (url, onSuccess, onEerror) {
        angular.element(new Image()).bind('load', function () {
            onSuccess();
        }).bind('error', function () {
            onEerror();
        }).attr('src', url);
    };
});